import React from "react";
import arrowRight from "./images/arrow-right.svg";

const SuffixIcon = () => {
    return <img src={arrowRight} alt={"Arrow right"} height={16} width={16}/>;
};

export default SuffixIcon;
